export default __webpack_public_path__ + "static/media/videofooter.d801fdd0.mp4";